class ListboxEvent extends GUIEvent {
    index: number;
    event: any;

    constructor(identifier: string, action: Action, effect: Effect, index: number, event: any, handlerRequired: boolean = false) {
        super(identifier, action, effect, handlerRequired);
        this.index = index;
        this.event = event;
    }
}